import { createFileRoute } from '@tanstack/react-router'
import { Link } from '@tanstack/react-router'
import { useMsal } from '@azure/msal-react'
import {
  Typography,
  Card,
  CardContent,
  CardActionArea,
  Box,
  CircularProgress,
} from '@mui/material'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { getFirstName } from '@/auth/authHelpers'
import { useCoinBalance } from '@/hooks/useCoins'

export const Route = createFileRoute('/_authenticated/')({
  component: DashboardPage,
})

export function DashboardPage() {
  const { accounts } = useMsal()
  const account = accounts[0] ?? null
  const name = getFirstName(account)
  const { balance, loading } = useCoinBalance()

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Welkom {name}, bij jouw Road4Success!
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Bekijk hoe het gaat — goed bezig!
      </Typography>

      <Card sx={{ maxWidth: { xs: '100%', sm: 320 } }}>
        <CardActionArea component={Link} to="/coins">
          <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <MonetizationOnIcon sx={{ fontSize: 48, color: 'secondary.main' }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Mijn coins
              </Typography>
              {loading ? (
                <CircularProgress size={24} />
              ) : (
                <Typography variant="h3" sx={{ fontWeight: 700, color: 'secondary.main' }}>
                  {balance?.total_coins ?? 0}
                </Typography>
              )}
              <Typography variant="caption" color="text.disabled">
                coins
              </Typography>
            </Box>
            <ArrowForwardIcon color="action" />
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  )
}
